// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"67e55886","453":"472407dd","788":"f662f49f"}[chunkId] + ".chunk.js";
};